import { useWindowDimensions } from 'react-native';

/**
 * True when the viewport is wider than it is tall. On phones/tablets this maps
 * to landscape and on the web build to a wide browser window, so both can share
 * the same "horizontal mode" layout.
 */
export const useIsHorizontal = (): boolean => {
  const { width, height } = useWindowDimensions();

  return width > height;
};
